module.exports = __webpack_public_path__ + "img/Skoda.7842ab3c.png";